import apiClient from "../apiClient";

export const forgotPassword = (emailOrMobile) =>
  apiClient.post("/Auth/forgot-password", { emailOrMobile });

export const verifyOtp = (emailOrMobile, otp) =>
  apiClient.post("/Auth/verify-otp", { emailOrMobile, otp });

export const resetPassword = (resetToken, newPassword, confirmPassword) =>
  apiClient.post("/Auth/reset-password", {
    resetToken,
    newPassword,
    confirmPassword,
  });
